import { jsx as e } from "react/jsx-runtime";
const l = (t) => e("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "1.5em", height: "1.5em", fill: "currentColor", viewBox: "0 0 24 24", focusable: "false", "aria-hidden": "true" }, t, { children: e("path", { fill: "inherit", d: "M5.576 22V2L21.03 12z" }) }));
export {
  l as default
};
